import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import MenuFilters from '../components/MenuFilters';
import MenuGrid from '../components/MenuGrid';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { menuItems } from '../data/menuData';

const HomePage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedDietary, setSelectedDietary] = useState('all');

  const filteredItems = menuItems.filter(item => {
    const categoryMatch = selectedCategory === 'all' || item.category === selectedCategory;
    const dietaryMatch = selectedDietary === 'all' || item.dietary.includes(selectedDietary);
    return categoryMatch && dietaryMatch;
  });

  return (
    <div data-component-path="client/src/pages/HomePage.jsx" data-component-line="20:5" data-component-id="client/src/pages/HomePage.jsx:20:5" className="min-h-screen">
      <Navbar />
      <Hero />
      <main data-component-path="client/src/pages/HomePage.jsx" data-component-line="23:7" data-component-id="client/src/pages/HomePage.jsx:23:7" className="pt-20">
        <section data-component-path="client/src/pages/HomePage.jsx" data-component-line="24:9" data-component-id="client/src/pages/HomePage.jsx:24:9" id="menu" className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div data-component-path="client/src/pages/HomePage.jsx" data-component-line="25:11" data-component-id="client/src/pages/HomePage.jsx:25:11" className="text-center mb-12">
            <h2 data-component-path="client/src/pages/HomePage.jsx" data-component-line="26:13" data-component-id="client/src/pages/HomePage.jsx:26:13" className="section-title text-4xl md:text-5xl text-charcoal mb-4">
              Our Menu
            </h2>
            <p data-component-path="client/src/pages/HomePage.jsx" data-component-line="29:13" data-component-id="client/src/pages/HomePage.jsx:29:13" className="text-gray-600 text-lg max-w-2xl mx-auto">
              Artisanal coffee, wood-fired comfort food, and fresh ingredients crafted with care
            </p>
          </div>
          
          <MenuFilters 
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedDietary={selectedDietary}
            setSelectedDietary={setSelectedDietary}
          />
          
          <MenuGrid items={filteredItems} />
        </section>

        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;